import React from 'react';
import { Tag } from 'antd';
import { BurnInJobStatus, BURNIN_STATUS_COLORS } from '../types/burnInTypes';

interface Props {
  status: BurnInJobStatus;
}

const BurnInStatusTag: React.FC<Props> = ({ status }) => {
  const labels: Record<BurnInJobStatus, string> = {
    pending: 'Pending',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
  };
  return <Tag color={BURNIN_STATUS_COLORS[status]}>{labels[status]}</Tag>;
};

export default BurnInStatusTag;
